import { Link } from "react-router-dom";
import WebLayout from "../layout/WebLayout";
import { useSelector } from "react-redux";
import { useSellerFetch } from "../hooks/useSellerFetch";
import { useState } from "react";
import { useCategoryFetch } from "../hooks/useCategoryFetch";
import * as ReactShare from "react-share";

function VerifiedSeller() {
  const [search, setSearch] = useState("");
  const [categoryType, setCategoryType] = useState("");
  const { verifiedSellerList } = useSelector((state) => state.seller);
  const [isLoader] = useSellerFetch(search, categoryType);
  const { categories } = useSelector((state) => state.category);
  useCategoryFetch();

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [companyName, setCompanyName] = useState("");

  // Open Modal
  const openModal = (url) => {
    setShareUrl(url);
    setCompanyName();
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Copy to Clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    alert("Link copied to clipboard!");
  };

  console.log(verifiedSellerList);

  return (
    <WebLayout pageName={"VerifiedSeller"}>
      <section className="vendor-two py-20">
        <div className="container container-lg">
          <div className="d-flex align-items-center flex-wrap mb-10 gap-16">
            <div className="w-100 max-w-275">
              <select
                className="form-control form-select py-10"
                value={categoryType}
                onChange={(e) => setCategoryType(e.target.value)}>
                <option value="" disabled>
                  Select Category Type
                </option>
                {categories &&
                  categories.map((cat, index) => (
                    <option key={index} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="w-100 max-w-275">
              <input
                type="text"
                className="form-control common-input rounded-start-3 py-10"
                placeholder="Searching..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12 col-lg-12">
              {isLoader ? (
                <div className="text-center py-5">
                  <span
                    className="spinner-border text-primary"
                    role="status"></span>
                  <p>Loading verified sellers...</p>
                </div>
              ) : (
                <div className="list-grid-wrapper vendors-two-item-wrapper grid-cols-4">
                  {Array.isArray(verifiedSellerList) ? (
                    verifiedSellerList.map((seller, index) => {
                      const sellerProfileUrl = `https://indianmsme.org/${seller.username}`;
                      const subSellerUrl = `https://indianmsme.org/sub-seller-list/${seller.id}`;
                      const sellerUrl =
                        seller.subSellerStatus === true
                          ? subSellerUrl
                          : sellerProfileUrl;
                      const isBlacklisted =
                        seller.account_status === "BLACKLIST";

                      return (
                        <div
                          key={index}
                          className={`vendors-two-item rounded-12 overflow-hidden bg-color-three border border-neutral-50 hover-border-main-two-600 transition-2 ${
                            isBlacklisted ? "blacklisted-seller" : ""
                          }`}
                          style={{ position: "relative" }}>
                          {/* Verified Watermark */}
                          {!isBlacklisted && (
                            <div className="verified-watermark">
                              <i className="ph ph-check-circle"></i> Verified
                            </div>
                          )}

                          {/* Blacklisted Overlay */}
                          {isBlacklisted && (
                            <div className="blacklisted-overlay">
                              <div className="blacklisted-text">
                                <i className="ph ph-warning-circle"></i>{" "}
                                Blacklisted
                              </div>
                            </div>
                          )}

                          <div className="vendors-two-item__top bg-overlay style-two position-relative">
                            <div className="vendors-two-item__thumbs h-210">
                              <img
                                src={seller.companyBanner}
                                alt=""
                                className="cover-img"
                                style={
                                  isBlacklisted
                                    ? { filter: "grayscale(100%)" }
                                    : {}
                                }
                              />
                            </div>
                            <div className="position-absolute top-0 inset-inline-start-0 w-100 h-100 p-20 z-1 d-flex flex-column justify-content-between">
                              <div className="d-flex align-items-center justify-content-between">
                                <span
                                  className="w-80 h-80 flex-center bg-white rounded-circle flex-shrink-0"
                                  style={{ overflow: "hidden" }}>
                                  <img
                                    src={seller.companyLogo}
                                    alt=""
                                    style={
                                      isBlacklisted
                                        ? { filter: "grayscale(100%)" }
                                        : {}
                                    }
                                  />
                                </span>
                                {!isBlacklisted && (
                                  <button
                                    className="btn btn-light ms-2"
                                    onClick={() => {
                                      openModal(sellerUrl);
                                      setCompanyName(seller?.company_name);
                                    }}>
                                    <i className="ph ph-share-network text-main-two-600"></i>
                                  </button>
                                )}
                              </div>
                              <div className="mt-10">
                                <h6
                                  className={`fw-semibold mb-2 text-lg ${
                                    isBlacklisted ? "text-muted" : "text-white"
                                  }`}>
                                  <Link to="#" className="">
                                    {seller?.company_name} ({seller?.username})
                                  </Link>
                                </h6>
                                <p
                                  className={`text-md ${
                                    isBlacklisted ? "text-muted" : "text-white"
                                  }`}>
                                  {seller?.cName}
                                </p>
                                <div className="flex-align justify-content-between gap-6">
                                  <div>
                                    <span
                                      className={`text-md fw-medium ${
                                        isBlacklisted
                                          ? "text-muted"
                                          : "text-white"
                                      }`}>
                                      Total Product
                                    </span>
                                    <span
                                      className={`text-sm fw-medium ${
                                        isBlacklisted
                                          ? "text-muted"
                                          : "text-white"
                                      }`}>
                                      ({seller?.productCount})
                                    </span>
                                  </div>
                                  <div
                                    className={`badge ${
                                      isBlacklisted ? "bg-dark" : "bg-danger"
                                    } text-white`}
                                    style={{ fontWeight: 700 }}>
                                    <span className="text-md">MOA: &nbsp;</span>
                                    <span className="text-sm">
                                      {seller?.min_order_amount}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`vendors-two-item__content flex-grow-1 ${
                              isBlacklisted
                                ? "bg-dark"
                                : "bg-neutral-600 hover-bg-neutral-700"
                            } text-white`}>
                            <Link
                              to={isBlacklisted ? "#" : sellerUrl}
                              target="_blank"
                              className={`btn py-8 px-24 rounded-8 flex-center gap-8 fw-medium ${
                                isBlacklisted ? "btn-dark disabled" : ""
                              }`}>
                              {isBlacklisted
                                ? "Blacklisted Seller"
                                : "View all products"}
                              {!isBlacklisted && (
                                <span className="text-xl d-flex text-main-two-600">
                                  <i className="ph ph-storefront"></i>
                                </span>
                              )}
                            </Link>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>No verified sellers available.</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={closeModal}>
              ✖
            </button>
            <div className="modal-header  align-self-center">
              <div className="modal-info">
                <h6>{companyName}</h6>
                <p>Check out this seller on Indian MSME</p>
                <span className="source">indianmsme.org</span>
              </div>
            </div>
            <div className="share-buttons">
              <ReactShare.FacebookShareButton
                url={shareUrl}
                hashtag={`Check out this seller on Indian MSME ${shareUrl}`}>
                <ReactShare.FacebookIcon size={50} />
              </ReactShare.FacebookShareButton>
              <ReactShare.LinkedinShareButton
                url={shareUrl}
                title={`Check out this seller on Indian MSME ${shareUrl}`}>
                <ReactShare.LinkedinIcon size={50} />
              </ReactShare.LinkedinShareButton>
              <ReactShare.TwitterShareButton
                url={shareUrl}
                title={`Check out this seller on Indian MSME ${shareUrl}`}>
                <ReactShare.XIcon size={50} />
              </ReactShare.TwitterShareButton>
              <ReactShare.WhatsappShareButton
                url={shareUrl}
                title={`Check out this seller on Indian MSME`}
                separator=" - ">
                <ReactShare.WhatsappIcon size={50} />
              </ReactShare.WhatsappShareButton>
            </div>
            <button className="copy-btn" onClick={copyToClipboard}>
              <i className={"fa fa-copy text-secondary"}></i> Copy link
            </button>
          </div>
        </div>
      )}
    </WebLayout>
  );
}

export default VerifiedSeller;
